export default __webpack_public_path__ + "static/media/thyroid.be8f400c.svg";